import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'
import { SandboxesResponse, SandboxStatus } from 'interfaces/sandbox'

interface GetSandboxesParams {
  page?: number
  status?: SandboxStatus | ''
  searchQuery?: string
}

const fetchSandboxes = async (
  params: GetSandboxesParams = {}
): Promise<SandboxesResponse> => {
  const { page = 1, status, searchQuery } = params
  const urlParams = new URLSearchParams()

  urlParams.append('page', page.toString())
  urlParams.append('per_page', '25')

  if (status) {
    urlParams.append('status', status)
  }
  if (searchQuery) {
    urlParams.append('query', searchQuery)
  }

  const response = await fetch(
    `${BASE_API_URL}/admin/api/v4/sandboxes?${urlParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  return handledResponse.json()
}

const useGetSandboxes = (params: GetSandboxesParams = {}) => {
  return useQuery(['sandboxes', params], () => fetchSandboxes(params), {
    refetchOnWindowFocus: false,
    staleTime: 60000,
    keepPreviousData: true,
  })
}

export default useGetSandboxes
